import styled from 'styled-components';
import { buttonBase } from '../styled';
import { getButtonSize, getToggleButtonAppearance } from '../utils';
import { stretchButton } from '../utils/stretchButton';
export const ToggleButton = styled.button `
  ${buttonBase};

  ${stretchButton};

  ${(props) => getToggleButtonAppearance(props.appearance, props.$toggled)}
  ${(props) => getButtonSize(props.size)};
`;
